import { type TicketStatus } from "../../graphql/supergraphTypes";

export const TICKET_STATUS_DISPLAY_MAP: Record<TicketStatus, string> = {
  IN_PROGRESS: "In Progress",
  DONE: "Done",
  TO_DO: "To Do",
  INDEXING: "Indexing",
  PENDING_CLIENT: "Pending Client",
  BLOCKED: "Blocked",
  COMPLETE: "Complete",
  IN_REVIEW: "In Review",
  WILL_NOT_DO: "Will Not Do",
  MAKER: "Maker",
  CHECKER: "Checker",
  INCOMPLETE: "Incomplete",
};

export const COMMENT_ERROR_TOAST_ID = "workflow-comment-adf-to-html-conversion-error";

export const JIRA_PROJECT_KEY = "FA";

export const JIRA_BASE_URL = "https://junipersquare.atlassian.net";

export const TICKETS_TABLE_PAGE_SIZE = 20;

export const WORKFLOW_TABLE_PAGE_SIZE = 20;

// Matches the BE's MAX_LIMIT cap on controlTowerWorkflows (control_tower/constants.py) —
// the largest page size a single request will honor, used to page through
// every workflow when exporting "all" instead of just the current grid page.
export const WORKFLOW_EXPORT_PAGE_SIZE = 100;

export const UNASSIGNED_FILTER_VALUE = "Unassigned";

export const FIELDS_REQUIRING_UNASSIGNED_OPTION = [
  "customers",
  "entityName",
  "assignedTo",
  "faPreparer",
  "faReviewer",
  "isPrimary",
  "isReviewer",
] as const;

export const URL_PARAMS = {
  FILTERS_PARAM: "filters",
  SORTS_PARAM: "sorts",
} as const;
